export default {
    methods: {
        trackEvent(name, subEvent, props = null) {
            let eventName = `Autodesk One - ${name}`;
            let params = {}
            if (subEvent) {
                params.subEvent = subEvent
            }
            if(props) {
                Object.assign(params, props);
            }
            this.$hhMixpanel.trackEvent(eventName, params);
        },

        trackAutodeskOnePageHit(pageTitle) {
            this.trackEvent(`Page Hit: ${pageTitle}`);
            document.title = `Autodesk One - ${pageTitle}`;
        },

        trackResource(subEvent) {
            this.trackEvent("resource clicked", subEvent);
        }, 

        trackTopStoryClick(subEvent) {
            this.trackEvent("top story clicked", subEvent);
        },

        trackPopularLink(subEvent) {
            this.trackEvent("popular link selected", subEvent);
        },

        trackCalendarEventClick(subEvent) {
            this.trackEvent("calendar event selected", subEvent)
        },

        trackViewAllClick(event) {
            // commonly used in side panel
            this.trackEvent(event);
        },

        trackNewsByInterestStoryClick(subEvent) {
            this.trackEvent("news by interest story clicked", subEvent);
        },

        trackEventsByInterestEventClick(subEvent) {
            this.trackEvent("calendar event selected - all events", subEvent);
        },

        trackNewsEditInterestsClick() {
            this.trackEvent("edit news interests clicked");
        },

        trackEventsEditInterestsClick() {
            this.trackEvent("edit events interests clicked");
        },

        trackAddEventToCalendar(subEvent) {
            this.trackEvent("add to calendar clicked", subEvent);
        },

        trackSubscribedToTopic(subscribed, topic, type) {
            let eventType = type ? type : '';
            let event = (subscribed) ? `subscribed to ${eventType} topic` : `unsubscribed from ${eventType} topic`;
            this.trackEvent(event, topic);
        },
        trackOneMobilePilotClick() {
            this.trackEvent("One Mobile pilot visit click");
        },
        trackNewsInterestsUpdated(subEvent) {
            this.trackEvent("news interests updated", subEvent);
        },

        trackNewsFeedLoadMoreClicked(event) {
            this.trackEvent(event);
        },

        trackMyContentClicked(subEvent) {
            this.trackEvent("my content link clicked", subEvent);
        },
        
        trackCampaign(subEvent) {
            this.trackEvent("Campaign Banner", subEvent);
        },

        trackOutageAnnouncement(subEvent) {
            this.trackEvent("Outage Announcement", subEvent);
        },

        trackPanelFooterClick(event) {
            this.trackEvent(event);
        },

        trackBackButtonClick() {
            this.trackEvent("Back clicked");
        },

        trackBookmarkClick(subEvent) {
            this.trackEvent("bookmark clicked", subEvent)
        },
        
        trackViewBookmark(subEvent) {
            this.trackEvent("View bookmark clicked", subEvent)
        },

        trackBookmarkPinUpdate(pinned, subEvent) {
            this.trackEvent(`Bookmark ${pinned}`, subEvent)
        },

        trackRecommendedLinkAdded(subEvent) {
            this.trackEvent(`Recommended link added`, subEvent)
        },

        trackCampaignCarouselClick(subEvent) {
            // subEvent equal to previous/next
            this.trackEvent(`Campaign carousel clicked`, subEvent)
        },

        trackGenerateViewNewsSummaryClicked() {
            this.trackEvent("View news summary clicked")
        },

        trackGenAiNewsReadMoreClicked(subEvent) {
            this.trackEvent(`Generative AI news summary read more clicked`, subEvent)
        },

        trackGenAiShareNewsSummaryClicked(subEvent) {
            this.trackEvent("Generative AI news summary shared", subEvent)
        },

        trackVideoCampaignPostClick(subEvent) {
            this.trackEvent("Video Campaign post clicked", subEvent);
        },

        trackVideoCampaignClick(subEvent) {
            this.trackEvent("Video Campaign played", subEvent);
        },

        trackNewsFeedFilteredSearch(subEvent, props) {
            this.trackEvent("News Feed filtered search", subEvent, props);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/HomebaseMixpanelMixin.js